import { TsLinkUser } from './../model/ts-link-user.model';
import { UserInfo } from './../model/user-info.model';
export class BaseStateModel {
    token: string;
    userInfo: TsLinkUser;
}
